<script setup>
import { useAppStore } from '@/stores/App'
//import { useDisplay } from 'vuetify'

// mobile breakpoint
//const { xs } = useDisplay()
// Vars
const app = useAppStore()
const staticURLImg = useRuntimeConfig().public.staticURLImg
</script>

<template>
    <v-row id="soundesign" class="justify-center slide-from-left">
        <v-col cols="12" sm="10" class="rounded">
            <v-row dense>
                <!-- <v-col cols="12" class="text-h4 text-md-h3 text-center font-weight-medium st-text-shadow">
                    Shaping the Sounds
                </v-col> -->
                <v-col cols="12" class="mt-16 mb-4">
                    <app-section-header :id="`sd`" :title="`Shaping the Sounds`" :subtitle="``" />
                </v-col>
                <v-col cols="12" class="mb-6 text-center st-card-text-grey-lt2">
                    Our journey began with a deep love for music and a desire to push the boundaries of sonic
                    possibilities. This passion led us to delve into the world of sound design, where we have honed our
                    skills and collaborated with some of the biggest names in the audio plugin industry.
                </v-col>

                <v-col cols="12" md="12">
                    <v-card class="st-card pa-3 fill-height text-center st-box-shadow">
                        <v-card-item>
                            <v-icon color="blue-darken-3" size="48"> mdi-audio-input-xlr </v-icon>
                            <v-card-title class="py-1 text-h4 text-wrap"> A Legacy of Sound </v-card-title>
                        </v-card-item>
                        <v-card-text class="pa-2 text-center st-card-text">
                            Our impressive track record includes contributions to factory sound libraries for
                            industry-leading plugins by companies like:
                        </v-card-text>
                        <v-container>
                            <v-row>
                                <v-col
                                    v-for="client in app.sdClients"
                                    :key="client.alt"
                                    cols="6"
                                    sm="2"
                                    class="pa-1 text-center"
                                >
                                    <v-img
                                        :src="staticURLImg + client.source"
                                        class="rounded"
                                        :alt="`${client.alt} logo`"
                                    ></v-img>
                                    <!-- <div class="text-caption font-weight-medium">{{ client.alt }}</div> -->
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-card-text class="pa-2 text-center st-card-text">
                            These collaborations showcase our ability to create diverse and inspiring sounds that cater
                            to a wide range of musical styles.
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card class="st-card pa-3 text-center st-box-shadow">
                        <v-card-item>
                            <v-icon color="orange-darken-2" size="48"> mdi-music-box-multiple </v-icon>
                            <v-card-title class="my-2 text-h5"> Demo Track Creation </v-card-title>
                        </v-card-item>
                        <v-card-text class="st-card-text">
                            Our expertise extends beyond factory presets. We can bring plugins to life with captivating
                            demo tracks that showcase their sonic potential.
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card class="st-card pa-3 fill-height text-center st-box-shadow">
                        <v-card-item>
                            <v-icon color="deep-purple" size="48"> mdi-audio-input-rca </v-icon>
                            <v-card-title class="my-2 text-h5"> Custom Sound Design </v-card-title>
                        </v-card-item>
                        <v-card-text class="st-card-text">
                            Creating bespoke sound libraries tailored to the specific needs of clients is our expertise.
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" class="mt-4 mb-16 text-center">
                    <div class="mb-4 text-center st-card-text-grey-lt2">
                        We are constantly pushing the boundaries of sound design, exploring new techniques and
                        technologies to create sonic experiences that captivate and inspire.
                    </div>
                    <v-btn text="Contact Us" to="/support" size="x-large" color="deep-orange-accent-4"></v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped></style>
